import React, { Fragment, useState } from 'react';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/List";
import Collapse from "@material-ui/core/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },

    {
        id: 2,
        title: 'About',
        link: '/about',
    },

    {
        id: 6,
        title: 'Services',
        link: '/web-development-services',
        submenu: [
            {
                id: 61,
                title: 'WebCraft',
                link: '/web-development-services'
            },
            {
                id: 62,
                title: 'Digitally',
                link: '/digital-marketing-services'
            },
            // {
            //     id: 63,
            //     title: 'Service S3',
            //     link: '/service-s3'
            // },
            // {
            //     id: 64,
            //     title: 'Service single',
            //     link: '/service-single/1'
            // },
        ]
    },
    {
        id: 7,
        title: 'Solutions',
        link: '/real-estate-solutions',
        submenu: [
            {
                id: 71,
                title: 'Real Estate',
                link: '/real-estate-solutions'
            },
            {
                id: 72,
                title: 'Health Care',
                link: '/healthcare-it-solutions'
            },
            {
                id: 73,
                title: 'Fashion',
                link: '/fashion-ecommerce-solutions'
            },
            {
                id: 74,
                title: 'IT Solutions',
                link: '/it-consulting-solutions'
            },
            {
                id: 75,
                title: 'Education',
                link: '/education-technology-solutions'
            },
            {
                id: 76,
                title: 'Manufacturing',
                link: '/manufacturing-digital-solutions'
            },
            {
                id: 77,
                title: 'Finance',
                link: '/finance-software-solutions'
            },
            {
                id: 78,
                title: 'Home & Others',
                link: '/custom-digital-solutions'
            }
        ]
    },

    // {
    //     id: 3,
    //     title: 'Pages',
    //     link: '/',
    //     submenu: [
    //         {
    //             id: 31,
    //             title: 'Team',
    //             link: '/team'
    //         },
    //         {
    //             id: 322,
    //             title: 'Team Single',
    //             link: '/team-single/1'
    //         },
    //         {
    //             id: 371,
    //             title: 'Shop',
    //             link: '/shop',
    //         },
    //         {
    //             id: 375,
    //             title: 'Shop Single',
    //             link: '/product-single/1'
    //         },
    //         {
    //             id: 376,
    //             title: 'Cart',
    //             link: '/cart'
    //         },
    //         {
    //             id: 377,
    //             title: 'Checkout',
    //             link: '/checkout'
    //         },
    //         {
    //             id: 33,
    //             title: 'Pricing',
    //             link: '/pricing'
    //         },
    //         {
    //             id: 34,
    //             title: '404 Error',
    //             link: '/404'
    //         },
    //         {
    //             id: 35,
    //             title: 'Login',
    //             link: '/login'
    //         },
    //         {
    //             id: 36,
    //             title: 'Register',
    //             link: '/register'
    //         },
    //     ]
    // },

    // {
    //     id: 5,
    //     title: 'Blog',
    //     link: '/blog',
    //     submenu: [
    //         {
    //             id: 51,
    //             title: 'Blog',
    //             link: '/blog'
    //         },
    //         {
    //             id: 52,
    //             title: 'Blog Left sidebar',
    //             link: '/blog-left'
    //         },
    //         {
    //             id: 53,
    //             title: 'Blog full width',
    //             link: '/blog-fullwidth'
    //         },
    //         {
    //             id: 54,
    //             title: 'Blog single',
    //             link: '/blog-single/1'
    //         },
    //         {
    //             id: 55,
    //             title: 'Blog single Left sidebar',
    //             link: '/blog-single-left-sidebar/1'
    //         },
    //         {
    //             id: 56,
    //             title: 'Blog single Left sidebar',
    //             link: '/blog-single-fullwidth/1'
    //         },
    //     ]
    // },
    {
        id: 88,
        title: 'Contact',
        link: '/contact',
    }


]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null}  key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                          <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <NavLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</NavLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <NavLink className="active"
                                        to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;